import { Fab, FabProps, SxProps, Theme } from "@mui/material";

export interface AppFwFabProps extends FabProps {
}

const fabSx: SxProps<Theme> = {
    position: "fixed",
    float: "right",
    bottom: 72,
    right: 16,
}

export default function AppFwFab(props: AppFwFabProps) {
    return (
        <Fab
            color="primary"
            {...props}
            sx={[
                fabSx,
                ...(Array.isArray(props.sx) ? props.sx : [props.sx])
            ]}
        >
            {props.children}
        </Fab>
    )
}
